function Loading() {
  return (
    <div className="flex justify-center items-center mt-24">
      <img className="animate-bounce" src="favicon.ico" />
    </div>
  )
}
export default Loading;